import { Layout, Typography } from "antd";
import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const { Footer } = Layout;
const { Text } = Typography;

export function LandingFooter() {
  return (
    <Footer className="landing-footer">
      <div className="landing-footer-columns">
        <div className="landing-footer-brand">
          <Link to="/" className="landing-footer-logo">
            <Plane size={22} className="landing-logo-icon" />
            <strong>Hairplane</strong>
          </Link>

          <Text>
            The salon management platform built for salon and barbershop
            professionals.
          </Text>
        </div>

        <div className="landing-footer-col">
          <Text strong className="landing-footer-heading">Product</Text>
          <a href="#how-it-works">How It Works</a>
          <a href="#pricing">Pricing</a>
          <a href="#">Features</a>
          <a href="#">Mobile App</a>
        </div>

        <div className="landing-footer-col">
          <Text strong className="landing-footer-heading">Company</Text>
          <a href="#">About Us</a>
          <a href="#reviews">Customer Stories</a>
          <a href="#">Blog</a>
          <a href="#">Careers</a>
        </div>

        <div className="landing-footer-col">
          <Text strong className="landing-footer-heading">Support</Text>
          <a href="#">Help Center</a>
          <a href="#">Contact Us</a>
          <Link to="/login">Sign In</Link>
          <a href="#">API Docs</a>
        </div>
      </div>

      <div className="landing-footer-bottom">
        <Text>© 2026 Hairplane. All rights reserved.</Text>
        <div className="landing-footer-legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </Footer>
  );
}
